module.exports = __webpack_public_path__ + "static/hero-mobile-978130c99e44825a8a8bc94c836bb976.svg";